export const computeData = async (parentState) => {

    const response = await fetch("/api/calculateinternal", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(parentState)
    });
    var responseJson = await response.json();
    return responseJson;
}
